import React from 'react'
import { Embed } from 'semantic-ui-react'
import { Waypoint } from 'react-waypoint'

require('ta-semantic-ui/semantic/dist/components/embed.css')
require('ta-semantic-ui/semantic/dist/components/label.css')
require('ta-semantic-ui/semantic/dist/components/icon.css')
require('./styles.scss')

export default class PanoEmbed extends React.PureComponent {
  constructor(props) {
    super(props)

    this.isMobile = window.innerWidth < 600

    this.ua = window.navigator.userAgent
    this.isAndroidNativeApp = /app-android-smartphone/.test(this.ua)
    this.isIOSNativeApp = /app-ios-smartphone/.test(this.ua)
    this.isFullscreenEnabled =
      document.fullscreenEnabled ||
      document.webkitFullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled ||
      false

    this.state = {
      isActive: false
    }

    this.enterHandler = this.enterHandler.bind(this)
    this.leaveHandler = this.leaveHandler.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.maximize = this.maximize.bind(this)
  }

  renderFullScreenButton() {
    const style = {
      position: 'absolute',
      top: '0',
      right: '0',
      marginRight: 0
    }
    const className = `ui icon labeled ${
      this.isMobile ? 'small' : ''
    } primary button`
    const buttonText = `In voller Grösse ${this.isMobile ? '' : 'anzeigen'}`

    // If fullscreen is enabled, we use that function to show the iframe in
    // all it's glory. This also works on the Android native app – users can
    // get back using the native back button.
    if (this.isFullscreenEnabled) {
      return (
        <button className={className} onClick={this.maximize} style={style}>
          <i className='maximize icon' /> {buttonText}
        </button>
      )
    }

    // If fullscreen is not enabled, we just link to the URL – and assume
    // that people again will use the back button to go back.
    if (!this.isFullscreenEnabled) {
      return (
        <a className={className} style={style} href={this.props.url}>
          {' '}
          <i className='maximize icon' /> {buttonText}
        </a>
      )
    }
  }

  render() {
    return (
      <Waypoint
        scrollableAncestor={window}
        topOffset={'-50%'}
        onEnter={this.enterHandler}
        onLeave={this.leaveHandler}
      >
        <figure className='ui vertical segment pano-embed'>
          <div
            style={{ position: 'relative' }}
            ref={element => {
              this.embedElement = element
            }}
          >
            <Embed
              url={this.props.url}
              placeholder={this.props.poster}
              icon='bullseye'
              aspectRatio={'4:3'}
              onClick={this.clickHandler}
              active={this.state.isActive}
            />
            <div
              aria-hidden='true'
              className={`ui teal top left attached ${
                this.isMobile ? 'small' : 'large'
              } label`}
            >
              <i className='bullseye icon' />
              360°
            </div>

            {this.state.isActive && this.renderFullScreenButton()}
          </div>

          <figcaption className='ui very fitted vertical segment'>
            <div className='ui container'>
              <p className='ta caption'>{this.props.caption}</p>
            </div>
          </figcaption>
        </figure>
      </Waypoint>
    )
  }

  leaveHandler(event) {
    if (!window.app.inFullscreen) {
      this.setState({ isActive: false })
    }
  }

  enterHandler(event) {
    // Only auto-activate on desktop devices
    if (window.innerWidth > 800) {
      this.setState({ isActive: true })
    }
  }

  clickHandler(event) {
    this.setState({ isActive: true })
  }

  maximize(event) {
    let iframe = this.embedElement.querySelector('div.embed iframe')
    window.app.inFullscreen = true
    let requestFullscreen =
      iframe.requestFullscreen ||
      iframe.webkitRequestFullscreen ||
      iframe.mozRequestFullScreen ||
      iframe.msRequestFullscreen
    requestFullscreen.call(iframe)
  }
}

PanoEmbed.propTypes = {}
// url: React.PropTypes.string.isRequired,
// poster: React.PropTypes.string.isRequired,
// caption: React.PropTypes.string
PanoEmbed.defaultProps = {
  caption: ''
}
